export const NAME_PAGE_ELEMENTS = {
  QUICK_SEARCH: "mpiQuickSearch",
  VEHICLE_LIST: "mpiVehicleList",
  VEHICLE_DETAIL: "mpiVehicleDetail",
  DETAIL_SEARCH: "mpiDetailSearch",
  SLIDER: "mpiSlider"
};
